module.exports = __webpack_public_path__ + "static/media/Passo2a.233b60ec.233b60ec.JPG";